/* ============================================================
   Anime Alley, live events calendar
   Pulls real ticket products from /collections/<handle>/products.json,
   renders a FullCalendar-style month grid (default) + list view,
   category-coloured tiles with game logos, hover tooltips, filter tabs.
   Ported from the Anime Alley design prototype.
   ============================================================ */
(function () {
  'use strict';
  var cfg = window.AA_EVENTS;
  var app = document.querySelector('[data-events-app]');
  if (!cfg || !app) return;
  var S = cfg.strings || {};
  var L = cfg.logos || {};

  var state = {
    filter: 'all',
    view: cfg.defaultView === 'list' ? 'list' : 'calendar',
    status: 'loading',
    live: [],
    serverEvents: (cfg.events || []),
    month: null
  };

  /* ---------- helpers ---------- */
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function escAttr(s) { return esc(s).replace(/"/g, '&quot;'); }
  function money(dollars) {
    var cents = Math.round(parseFloat(dollars || 0) * 100);
    return window.formatMoney ? window.formatMoney(cents) : ('$' + (cents / 100).toFixed(2));
  }
  function tagsOf(p) {
    if (Array.isArray(p.tags)) return p.tags;
    if (typeof p.tags === 'string') return p.tags.split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    return [];
  }
  function keyOf(d) { return d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate(); }
  function handleFromUrl(url) { return String(url || '').split('?')[0].split('/').filter(Boolean).pop() || ''; }
  function usingServer() { return state.serverEvents && state.serverEvents.length > 0; }

  function parseEventDateTime(p) {
    var text = (p.title || '') + ' ' + ((p.body_html || '').replace(/<[^>]+>/g, ' ')) + ' ' + tagsOf(p).join(' ');
    var M = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
    var date = null, m;
    if ((m = text.match(/\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\.?\s+(\d{1,2})(?:,?\s*(\d{4}))?/i))) {
      var y1 = m[3] ? +m[3] : new Date().getFullYear();
      date = new Date(y1, M[m[1].slice(0, 3).toLowerCase()], +m[2]);
    } else if ((m = text.match(/\b(\d{1,2})\s+(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\.?(?:,?\s*(\d{4}))?/i))) {
      var y2 = m[3] ? +m[3] : new Date().getFullYear();
      date = new Date(y2, M[m[2].slice(0, 3).toLowerCase()], +m[1]);
    } else if ((m = text.match(/\b(\d{1,2})\/(\d{1,2})(?:\/(\d{2,4}))?\b/))) {
      var y3 = m[3] ? +m[3] : new Date().getFullYear();
      if (y3 < 100) y3 += 2000;
      var mo = +m[1], da = +m[2];
      if (mo > 12 && da <= 12) { var tmp = mo; mo = da; da = tmp; } // first group can't be a month → treat as D/M
      date = new Date(y3, mo - 1, da);
    }
    var time = null;
    var t = text.match(/\b(\d{1,2})(?::(\d{2}))?\s*([ap]\.?m\.?)/i);
    if (t) time = t[1] + (t[2] ? ':' + t[2] : '') + ' ' + t[3].replace(/\./g, '').toUpperCase();
    return { date: date, time: time };
  }

  function eventMeta(title, tags) {
    var t = (title || '').toLowerCase();
    var g = (tags || []).join(' ').toLowerCase();
    var cls = 'default', logo = null;
    if (t.indexOf('pokemon') > -1 || t.indexOf('pokémon') > -1 || g.indexOf('event-pokemon') > -1 || g.indexOf('pokemon') > -1) {
      cls = 'pokemon';
      if (t.indexOf(' go') > -1 || g.indexOf('pokemon-go') > -1 || t.indexOf('pokemon go') > -1) logo = L.pokemonGo;
      else if (t.indexOf('vgc') > -1 || g.indexOf('vgc') > -1) logo = (t.indexOf('mid') > -1 || g.indexOf('mid') > -1) ? L.vgcMSS : L.vgcPremier;
      else if (t.indexOf('challenge') > -1 || g.indexOf('challenge') > -1) logo = L.leagueChallenge;
      else if (t.indexOf('cup') > -1 || g.indexOf('cup') > -1) logo = L.leagueCup;
      else if (t.indexOf('build') > -1 || g.indexOf('build') > -1) logo = L.buildAndBattle;
      else logo = L.playPokemon;
    } else if (g.indexOf('event-one-piece') > -1 || g.indexOf('one piece') > -1 || t.indexOf('one piece') > -1) { cls = 'op'; logo = L.onePiece; }
    else if (g.indexOf('event-mtg') > -1 || g.indexOf('mtg') > -1 || t.indexOf('magic') > -1) { cls = 'mtg'; logo = L.mtg; }
    else if (g.indexOf('event-riftbound') > -1 || g.indexOf('riftbound') > -1 || t.indexOf('riftbound') > -1 || g.indexOf('nexus') > -1 || t.indexOf('nexus') > -1) { cls = 'riftbound'; logo = L.riftbound || L.ua; }
    else if (g.indexOf('union arena') > -1 || t.indexOf('union arena') > -1) { cls = 'ua'; logo = L.ua; }
    else if (g.indexOf('flesh-and-blood') > -1 || g.indexOf('flesh and blood') > -1 || t.indexOf('flesh and blood') > -1 || t.indexOf('fab') > -1) { cls = 'fab'; logo = L.fab; }
    return { cls: cls, logo: logo };
  }

  /* ---------- computed ---------- */
  function liveEvents() {
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var list;
    if (usingServer()) {
      // Authoritative: dates come from the event_calendar.date_time metafield (rendered server-side).
      list = state.serverEvents.map(function (e, i) {
        var date, time;
        if (e.hasDate) {
          date = new Date(e.y, e.mo - 1, e.da);
          time = e.time || null;
        } else {
          // no event_calendar.date_time metafield, fall back to parsing the title
          var dt = parseEventDateTime({ title: e.title, body_html: e.desc, tags: e.tags });
          date = dt.date;
          time = dt.time;
        }
        return {
          p: {
            id: 'sp' + i,
            title: e.title,
            handle: handleFromUrl(e.url),
            url: e.url,
            tags: e.tags || [],
            body_html: e.desc || '',
            variants: [{ price: String(e.priceNum != null ? e.priceNum : 0), available: !!e.available }],
            images: e.image ? [{ src: e.image }] : []
          },
          date: date,
          time: time
        };
      });
    } else {
      list = state.live.map(function (p) {
        var dt = parseEventDateTime(p);
        return { p: p, date: dt.date, time: dt.time };
      });
    }
    return list.filter(function (e) { return !e.date || e.date >= today; })
      .sort(function (a, b) { return (a.date ? a.date.getTime() : Infinity) - (b.date ? b.date.getTime() : Infinity); });
  }
  function normCatTag(t) {
    // "Nexus Night" is our recurring Riftbound event, same game, so fold it into Riftbound
    if (/nexus/i.test(t)) return 'Riftbound';
    return t;
  }
  function liveCats(events) {
    var freq = {};
    events.forEach(function (e) {
      var seen = {};
      tagsOf(e.p).forEach(function (t) {
        if (t === 'Event' || /^event-/i.test(t)) return;
        var nt = normCatTag(t);
        if (seen[nt]) return; // count each (normalised) category once per event
        seen[nt] = true;
        freq[nt] = (freq[nt] || 0) + 1;
      });
    });
    return Object.keys(freq).sort(function (a, b) { return freq[b] - freq[a]; }).slice(0, 7);
  }
  function filtered(events) {
    return events.filter(function (e) {
      if (state.filter === 'all') return true;
      return tagsOf(e.p).some(function (t) { return normCatTag(t) === state.filter; });
    });
  }
  function calItems(events) {
    return filtered(events).filter(function (e) { return e.date; }).map(function (e) {
      var meta = eventMeta(e.p.title, tagsOf(e.p));
      var prices = (e.p.variants || []).map(function (v) { return parseFloat(v.price); }).filter(function (n) { return !isNaN(n); });
      var min = prices.length ? Math.min.apply(null, prices) : 0;
      var desc = (e.p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 200);
      var img = e.p.images && e.p.images[0] && e.p.images[0].src;
      return {
        date: e.date, time: e.time, title: e.p.title,
        available: (e.p.variants || []).some(function (v) { return v.available; }),
        url: '/products/' + e.p.handle, catClass: meta.cls,
        logo: meta.logo, image: img,
        price: min === 0 ? S.free : money(min), desc: desc
      };
    });
  }

  /* ---------- views ---------- */
  function liveEventCardHTML(e, featured) {
    var p = e.p;
    var inStock = (p.variants || []).some(function (v) { return v.available; });
    var prices = (p.variants || []).map(function (v) { return parseFloat(v.price); }).filter(function (n) { return !isNaN(n); });
    var min = prices.length ? Math.min.apply(null, prices) : 0;
    var img = p.images && p.images[0] && p.images[0].src;
    var dstr = e.date ? e.date.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' }) : null;
    var tags = tagsOf(p).filter(function (t) { return t !== 'Event' && !/^event-/i.test(t); }).slice(0, 2);
    return '<a href="/products/' + p.handle + '" class="event-card' + (featured ? ' featured' : '') + '">' +
      '<div class="event-card-img">' + (img ? '<img src="' + img + '" alt="" width="108" height="108" loading="lazy">' : iconCal()) + '</div>' +
      '<div class="event-card-body">' +
        '<div class="event-card-tags">' +
          (dstr ? '<span class="pill pill-gold">' + iconCalSm() + esc(dstr) + (e.time ? ' · ' + esc(e.time) : '') + '</span>' : '') +
          tags.map(function (t) { return '<span class="pill pill-green">' + esc(t) + '</span>'; }).join('') +
        '</div>' +
        '<h3 class="event-card-title">' + esc(p.title) + '</h3>' +
        '<p class="event-card-avail' + (inStock ? '' : ' sold') + '">' + (inStock ? S.ticketsAvailable : S.soldOut) + '</p>' +
      '</div>' +
      '<div class="event-card-right">' +
        '<span class="event-card-price">' + (min === 0 ? S.free : money(min)) + '</span>' +
        '<span class="btn btn-sm ' + (inStock ? 'btn-primary' : 'btn-ghost') + '" style="min-width:112px;">' + (inStock ? S.getTickets : S.view) + '</span>' +
      '</div></a>';
  }

  function listViewHTML(events) {
    var rows = filtered(events);
    var feat = events.find(function (e) { return (e.p.variants || []).some(function (v) { return v.available; }); }) || events[0] || null;
    var html = '';
    if (state.status === 'live' && feat && state.filter === 'all') {
      html += '<div class="event-featured-wrap"><div class="lead"><span class="pill pill-gold">' + iconSpark() + S.nextUp + '</span></div>' +
        '<div style="padding:6px;">' + liveEventCardHTML(feat, true) + '</div></div>';
    }
    html += '<div class="events-list">';
    var listRows = rows.filter(function (e) { return state.filter !== 'all' || !feat || e.p.id !== feat.p.id; });
    if (listRows.length === 0) html += '<div class="center muted" style="padding:30px;">' + S.noneCategory + '</div>';
    else html += listRows.map(function (e) { return liveEventCardHTML(e, false); }).join('');
    html += '<a href="' + cfg.collectionUrl + '" class="btn btn-ghost" style="align-self:center;margin-top:8px;">' + S.viewAllShop + ' ' + iconArrow() + '</a>';
    html += '</div>';
    return html;
  }

  function calTileHTML(it, idx) {
    var short = it.title.split(' - ')[0].split(' – ')[0];
    // prefer the game logo; fall back to the Shopify product image when there's no logo
    var src = it.logo || it.image || '';
    var onerr = (it.image && it.image !== src) ? ' onerror="this.onerror=null;this.src=\'' + it.image + '\'"' : '';
    return '<a class="cal-ev cat-' + it.catClass + (it.available ? '' : ' soldout') + '" href="' + (it.url || '#') + '" data-tip="' + idx + '">' +
      (src ? '<img class="cal-ev-img" src="' + src + '" alt="" width="104" height="62" loading="lazy"' + onerr + '>' : '') +
      (!it.available && src ? '<span class="cal-ev-soldtext">SOLD OUT</span>' : '') +
      '<span class="cal-ev-body"><span class="cal-ev-title">' + esc(short) + '</span>' +
      (it.time ? '<span class="cal-ev-time">' + esc(it.time) + '</span>' : '') + '</span></a>';
  }

  function calendarViewHTML(events) {
    var items = calItems(events);
    window._calItems = items; // for tooltip lookup
    // month cursor
    if (!state.month) {
      var firstWithDate = items.find(function (i) { return i.date; });
      var base = firstWithDate ? new Date(firstWithDate.date) : new Date();
      base.setDate(1); base.setHours(0, 0, 0, 0);
      state.month = base;
    }
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var byDay = {};
    items.forEach(function (it) { if (!it.date) return; var k = keyOf(it.date); (byDay[k] = byDay[k] || []).push(it); });
    // Sort each day's events chronologically: parse "9:00 AM" / "1:30 PM" into
    // minutes-since-midnight (plain string compare put 10:00 AM before 9:00 AM).
    function timeMinutes(t) {
      var m = /^(\d{1,2}):(\d{2})\s*([AP])/i.exec((t || '').trim());
      if (!m) return -1;
      var h = parseInt(m[1], 10) % 12;
      if (m[3].toUpperCase() === 'P') h += 12;
      return h * 60 + parseInt(m[2], 10);
    }
    Object.keys(byDay).forEach(function (k) {
      byDay[k].sort(function (a, b) {
        var ma = timeMinutes(a.time), mb = timeMinutes(b.time);
        if (ma !== mb) return ma - mb;
        return (a.time || '').localeCompare(b.time || '');
      });
    });
    // index items globally for tooltip (store by stable index)
    var flatIndex = {};
    items.forEach(function (it, i) { flatIndex[i] = it; });

    var year = state.month.getFullYear(), mo = state.month.getMonth();
    var startDow = new Date(year, mo, 1).getDay();
    var dim = new Date(year, mo + 1, 0).getDate();
    var cells = [];
    for (var i = 0; i < startDow; i++) cells.push(null);
    for (var d = 1; d <= dim; d++) cells.push(new Date(year, mo, d));
    while (cells.length % 7) cells.push(null);
    var dow = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var monthLabel = state.month.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });

    function tileForItem(it) { var idx = items.indexOf(it); return calTileHTML(it, idx); }

    var html = '<div style="padding-bottom:20px;">';
    html += '<div class="cal-head"><h3>' + esc(monthLabel) + '</h3><div class="cal-nav">' +
      '<button class="btn btn-ghost btn-sm" data-cal-today>' + S.today + '</button>' +
      '<button class="hdr-icon navbtn" data-cal-prev aria-label="' + S.prevMonth + '">' + iconChevL() + '</button>' +
      '<button class="hdr-icon navbtn" data-cal-next aria-label="' + S.nextMonth + '">' + iconChevR() + '</button>' +
      '</div></div>';

    // desktop grid
    html += '<div class="cal-month"><div class="cal-grid" style="margin-bottom:6px;">' +
      dow.map(function (x) { return '<div class="cal-dow">' + x + '</div>'; }).join('') + '</div><div class="cal-grid">';
    cells.forEach(function (cell, i) {
      if (!cell) { html += '<div class="cal-empty"></div>'; return; }
      var evs = byDay[keyOf(cell)] || [];
      var isToday = cell.getTime() === today.getTime();
      var isPast = cell < today;
      html += '<div class="cal-cell' + (isToday ? ' today' : '') + (isPast ? ' past' : '') + '">' +
        '<span class="cal-daynum">' + cell.getDate() + '</span>' +
        evs.map(tileForItem).join('') + '</div>';
    });
    html += '</div></div>';

    // mobile agenda
    var agendaDays = cells.filter(function (c) { return c && byDay[keyOf(c)]; });
    html += '<div class="cal-agenda">';
    if (agendaDays.length === 0) html += '<p class="muted center" style="padding:40px 10px;">' + S.noneMonth.replace('{month}', esc(monthLabel)) + '</p>';
    else {
      agendaDays.forEach(function (c) {
        html += '<div style="margin-bottom:18px;"><div class="cal-agenda-date">' +
          c.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' }) + '</div>' +
          byDay[keyOf(c)].map(tileForItem).join('') + '</div>';
      });
    }
    html += '</div></div>';
    return html;
  }

  /* ---------- chrome ---------- */
  function liveBadge(events) {
    return '<div class="live-badge"><span class="live-dot"></span>' +
      S.live + ' · ' + events.length + ' ' + S.upcoming + '</div>';
  }
  function fallbackNotice() {
    return '<div class="events-fallback">' + iconRefresh() + '<span>' + S.fallback + '</span></div>';
  }
  function controlsHTML(events) {
    var cats = state.status === 'live' ? liveCats(events) : [];
    var tabs = [['all', S.allEvents]].concat(cats.map(function (c) { return [c, c]; }));
    var html = '<div class="events-controls"><div class="events-tabs">';
    html += tabs.map(function (t) {
      return '<button class="events-tab" data-filter="' + escAttr(t[0]) + '" aria-pressed="' + (state.filter === t[0]) + '">' + esc(t[1]) + '</button>';
    }).join('');
    html += '</div><div class="events-view-toggle">' +
      '<button class="events-view-btn" data-view="list" aria-pressed="' + (state.view === 'list') + '">' + iconGrid() + S.list + '</button>' +
      '<button class="events-view-btn" data-view="calendar" aria-pressed="' + (state.view === 'calendar') + '">' + iconCalSm() + S.calendar + '</button>' +
      '</div></div>';
    return html;
  }

  /* ---------- render ---------- */
  function render() {
    if (state.status === 'loading') return;
    var events = state.status === 'live' ? liveEvents() : [];
    if (state.status === 'fallback') {
      app.innerHTML = fallbackNotice() +
        '<div class="center" style="padding:30px 20px;"><a class="btn btn-primary" href="' + cfg.collectionUrl + '">' + S.viewAllShop + ' ' + iconArrow() + '</a></div>';
      return;
    }
    var html = liveBadge(events) + controlsHTML(events);
    html += (state.view === 'list') ? listViewHTML(events) : calendarViewHTML(events);
    app.innerHTML = html;
  }

  /* ---------- tooltip ---------- */
  var tip = document.createElement('div');
  tip.className = 'cal-tip';
  document.body.appendChild(tip);
  function showTip(it, el) {
    if (!it) { tip.classList.remove('show'); return; }
    tip.innerHTML = '<div class="cal-tip-head cat-' + it.catClass + '">' + esc(it.title) + '</div>' +
      '<div class="cal-tip-body">' +
      '<div class="cal-tip-row"><span class="cal-tip-label">' + S.entryFee + '</span>' + esc(it.price) + '</div>' +
      (it.desc ? '<div class="cal-tip-row"><span class="cal-tip-label">' + S.eventDetails + '</span>' + esc(it.desc) + (it.desc.length >= 200 ? '…' : '') + '</div>' : '') +
      '<div class="cal-tip-cta">' + (it.available ? S.clickTickets : S.soldNotice) + '</div></div>';
    var r = el.getBoundingClientRect();
    var x = r.left; if (x > window.innerWidth - 316) x = window.innerWidth - 316; if (x < 8) x = 8;
    var y = r.bottom + 8; if (y > window.innerHeight - 230) y = Math.max(8, r.top - 230);
    tip.style.left = x + 'px'; tip.style.top = y + 'px';
    tip.classList.add('show');
  }

  /* ---------- delegated events ---------- */
  app.addEventListener('click', function (e) {
    var f = e.target.closest('[data-filter]');
    if (f) { state.filter = f.getAttribute('data-filter'); render(); return; }
    var v = e.target.closest('[data-view]');
    if (v) { state.view = v.getAttribute('data-view'); render(); return; }
    if (e.target.closest('[data-cal-prev]')) { shiftMonth(-1); return; }
    if (e.target.closest('[data-cal-next]')) { shiftMonth(1); return; }
    if (e.target.closest('[data-cal-today]')) { var d = new Date(); d.setDate(1); d.setHours(0, 0, 0, 0); state.month = d; render(); return; }
  });
  app.addEventListener('mouseover', function (e) {
    var tileEl = e.target.closest('[data-tip]');
    if (tileEl && window._calItems) { var it = window._calItems[+tileEl.getAttribute('data-tip')]; if (it) showTip(it, tileEl); }
  });
  app.addEventListener('mouseout', function (e) {
    if (e.target.closest('[data-tip]')) showTip(null);
  });
  function shiftMonth(n) {
    var d = new Date(state.month.getFullYear(), state.month.getMonth() + n, 1);
    d.setHours(0, 0, 0, 0); state.month = d; showTip(null); render();
  }

  /* ---------- load ---------- */
  if (usingServer()) {
    // Events were rendered server-side from the event_calendar.date_time metafield, no fetch needed.
    state.status = 'live';
    render();
  } else {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 9000);
    fetch(cfg.url, { signal: controller.signal, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) {
        var ps = (data.products || []);
        if (ps.length) { state.live = ps; state.status = 'live'; } else { state.status = 'fallback'; }
      })
      .catch(function () { state.status = 'fallback'; })
      .finally(function () { clearTimeout(timer); render(); });
  }

  /* ---------- inline icon helpers ---------- */
  function svg(inner, cls, extra) { return '<svg viewBox="0 0 24 24" class="icon ' + (cls || '') + '"' + (extra || '') + ' aria-hidden="true">' + inner + '</svg>'; }
  function iconCal() { return svg('<rect x="3.5" y="5" width="17" height="16" rx="2.5"/><path d="M3.5 9.5h17"/><path d="M8 3v4M16 3v4"/>', '', ' style="width:34px;height:34px;stroke:var(--green)"'); }
  function iconCalSm() { return svg('<rect x="3.5" y="5" width="17" height="16" rx="2.5"/><path d="M3.5 9.5h17"/><path d="M8 3v4M16 3v4"/>', 'icon-sm'); }
  function iconSpark() { return svg('<path d="M12 3l1.8 5.4L19 10l-5.2 1.6L12 17l-1.8-5.4L5 10l5.2-1.6z"/>', 'icon-xs'); }
  function iconArrow() { return svg('<path d="M4 12h15"/><path d="M13 6l6 6-6 6"/>', 'icon-sm'); }
  function iconGrid() { return svg('<rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/>', 'icon-sm'); }
  function iconChevL() { return svg('<path d="M15 5l-7 7 7 7"/>', 'icon-sm'); }
  function iconChevR() { return svg('<path d="M9 5l7 7-7 7"/>', 'icon-sm'); }
  function iconRefresh() { return svg('<path d="M4 12a8 8 0 0 1 13.7-5.6L20 8"/><path d="M20 4v4h-4"/><path d="M20 12a8 8 0 0 1-13.7 5.6L4 16"/><path d="M4 20v-4h4"/>', 'icon-sm', ' style="stroke:#8a6d1f;flex-shrink:0"'); }
})();
